import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import SharpenImage from '../../components/SharpenImage';

const SharpenPage: React.FC = () => (
  <ToolLayout
    title="Sharpen Image Online Free - Enhance Clarity | AllTools"
    description="Sharpen blurry images online. Enhance image clarity and detail with adjustable intensity. Free tool."
    canonicalPath="/sharpen-image"
  >
    <SharpenImage />
  </ToolLayout>
);

export default SharpenPage;
